document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-card-color-swatch]');
  if (!swatch) return;

  const card = swatch.closest('.product-card-wrapper');
  if (!card) return;

  card.querySelectorAll('[data-card-color-swatch]').forEach((item) => {
    const isSelected = item === swatch;
    item.classList.toggle('is-selected', isSelected);
    item.setAttribute('aria-pressed', String(isSelected));
  });

  const image = card.querySelector('.card__media .media > img.product-card-image, .card__media .media > img:first-of-type');
  if (image && swatch.dataset.imageSrc) {
    const media = image.closest('.card__media');
    if (media) media.classList.remove('is-image-loaded');
    image.src = swatch.dataset.imageSrc;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    if (swatch.dataset.imageWidth) image.width = Number(swatch.dataset.imageWidth);
    if (swatch.dataset.imageHeight) image.height = Number(swatch.dataset.imageHeight);
    image.alt = swatch.dataset.imageAlt || '';
    card.classList.add('product-card-wrapper--variant-selected');
  }

  if (swatch.dataset.variantUrl) {
    card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
      link.href = swatch.dataset.variantUrl;
    });
  }

  const price = card.querySelector('.price');
  if (price) {
    const currentPrice = Number(swatch.dataset.price || 0);
    const comparePrice = Number(swatch.dataset.comparePrice || 0);
    const isOnSale = comparePrice > currentPrice;
    const regularPrice = price.querySelector('.price__regular .price-item--regular');
    const saleComparePrice = price.querySelector('.price__sale .price-item--regular');
    const salePrice = price.querySelector('.price__sale .price-item--sale');

    if (regularPrice) regularPrice.textContent = swatch.dataset.priceFormatted || '';
    if (salePrice) salePrice.textContent = swatch.dataset.priceFormatted || '';
    if (saleComparePrice) saleComparePrice.textContent = swatch.dataset.comparePriceFormatted || '';
    price.classList.toggle('price--on-sale', isOnSale);
  }

  card.dataset.selectedVariantId = swatch.dataset.variantId || '';
  card.dispatchEvent(
    new CustomEvent('product-card:variant-change', {
      bubbles: true,
      detail: {
        variantId: swatch.dataset.variantId || '',
        url: swatch.dataset.variantUrl || '',
      },
    })
  );
});
